exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".links[data-v-bf8a17de]{margin-left:14px}.bold[data-v-bf8a17de]{font-weight:700}.link[data-v-bf8a17de]{font-weight:700;color:#494298}.order_add[data-v-bf8a17de]{font-size:14px;line-height:1.4;font-weight:700;color:rgba(0,0,0,.85)}.file[data-v-bf8a17de]{margin-bottom:10px}.files[data-v-bf8a17de]{display:-ms-flexbox;display:flex;gap:10px}.activity-order[data-v-bf8a17de],.order_text[data-v-bf8a17de]{font-size:14px;color:rgba(0,0,0,.85);line-height:1.4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bf8a17de","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/activities/card/order/ActivitiesOrderRequirements.vue
// module id = d0923e5c720863b53884
// module chunks = 20